import { Component, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../../_services/organisation/organisation-preferences.service';

@Component({
  selector: 'acabim-admin-onboarding-ltm-items-auto-generate',
  templateUrl: './onboarding-ltm-items-auto-generate.component.html',
  styleUrls: ['../styles.scss', './onboarding-ltm-items-auto-generate.component.scss']
})
export class OnboardingLtmItemsAutoGenerateComponent implements OnInit {

  isLoading = false;
  active = false;

  constructor(
      private readonly organisationPreferencesService: OrganisationPreferencesService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.organisationPreferencesService.getPreferences().subscribe(data => {
      if (data) {
        this.active = data.run_import_project_ltms_task;
        this.isLoading = false;
      }
    });
  }

  submit(value: boolean) {
    this.organisationPreferencesService.updatePreference('run_import_project_ltms_task', value).subscribe(res => {
      this.getPreferences();
    });
  }

} // EOC
